import { render, staticRenderFns } from "./GroupsTable.vue?vue&type=template&id=71abbab5&"
import script from "./GroupsTable.vue?vue&type=script&lang=js&"
export * from "./GroupsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports